import { inject, Injectable } from '@angular/core';
import {
  type WorkspaceUserItemFragment,
  type WorkspaceViewerHasPortfolioApplicationQuery,
  type WorkspaceViewerHasPortfolioApplicationQueryVariables,
  type WorkspaceViewerQueryQuery,
  type WorkspaceViewerQueryQueryVariables,
  type WorkspaceViewerWithCardsAndTasksQueryQuery,
  type WorkspaceViewerWithCardsAndTasksQueryQueryVariables,
  type WorkspaceViewerWithCustomSettingsQueryQuery,
  type WorkspaceViewerWithCustomSettingsQueryQueryVariables,
  type WorkspaceViewerWithProgramRolesQueryQuery,
  type WorkspaceViewerWithProgramRolesQueryQueryVariables,
} from '@reconcept-platform/shared/types';
import { type Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WorkspaceGraphQLService } from '../../workspace-graphql.service';
import {
  ViewerHasPortfolioApplicationQuery,
  ViewerQuery,
  ViewerWithCardsAndTasksQuery,
  viewerWithCustomSettingsQuery,
  ViewerWithProgramRolesQuery,
} from './viewer.queries';

export type WorkspaceViewer = WorkspaceUserItemFragment;

export type WorkspaceViewerWithCardsAndTasksQuery_Card =
  // @ts-expect-error TS2339 property does not exist
  WorkspaceViewerWithCardsAndTasksQueryQuery['viewer']['cards']['nodes'][number];

export type WorkspaceViewerWithCardsAndTasksQuery_Task =
  // @ts-expect-error TS2339 property does not exist
  WorkspaceViewerWithCardsAndTasksQueryQuery['viewer']['cardTasks']['nodes'][number];
@Injectable({
  providedIn: 'root',
})
export class ViewerApi {
  private workspaceGraphQLService = inject(WorkspaceGraphQLService);

  watchViewer(): Observable<WorkspaceViewer> {
    // @ts-expect-error TS2322 type not assignable
    return this.workspaceGraphQLService
      .watchQuery<WorkspaceViewerQueryQuery, WorkspaceViewerQueryQueryVariables>({
        query: ViewerQuery,
      })
      .pipe(map((result) => result.data.viewer));
  }

  watchViewerWithCardsAndTasks() {
    return this.workspaceGraphQLService
      .watchQuery<WorkspaceViewerWithCardsAndTasksQueryQuery, WorkspaceViewerWithCardsAndTasksQueryQueryVariables>({
        query: ViewerWithCardsAndTasksQuery,
      })
      .pipe(map((result) => result.data.viewer));
  }

  watchViewerWithProgramRoles() {
    return this.workspaceGraphQLService
      .watchQuery<WorkspaceViewerWithProgramRolesQueryQuery, WorkspaceViewerWithProgramRolesQueryQueryVariables>({
        query: ViewerWithProgramRolesQuery,
      })
      .pipe(map((result) => result.data.viewer));
  }

  watchViewerHasPortfolioApplication() {
    return this.workspaceGraphQLService
      .watchQuery<WorkspaceViewerHasPortfolioApplicationQuery, WorkspaceViewerHasPortfolioApplicationQueryVariables>({
        query: ViewerHasPortfolioApplicationQuery,
      })
      .pipe(map((result) => result.data.viewer));
  }

  watchViewerCustomSettings() {
    return this.workspaceGraphQLService
      .watchQuery<WorkspaceViewerWithCustomSettingsQueryQuery, WorkspaceViewerWithCustomSettingsQueryQueryVariables>({
        query: viewerWithCustomSettingsQuery,
      })
      .pipe(map((result) => result.data.viewer));
  }
}
